import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { FileText, Image, FilePlus, File, Download, ExternalLink } from "react-feather";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddFiles = ({ project_id }) => {
  const [files, setFiles] = useState([]);
  const [progress, setProgress] = useState({});
  const [showDropzone, setShowDropzone] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store already uploaded files

  // Fetch uploaded files on load
  useEffect(() => {
    if (project_id) {
      axios
        .get(`${baseurl}getFilesByProjectId/${project_id}`)
        .then((res) => {
          if (res.data.success) {
            setUploadedFiles(res.data.files);
          } else {
            toast.error("Failed to fetch uploaded files");
          }
        })
        .catch((err) => {
          console.error("Error fetching files:", err);
          toast.error("Error fetching uploaded files");
        });
    }
  }, [project_id]);

  const onDrop = (acceptedFiles) => {
    setFiles((prev) => [...prev, ...acceptedFiles]);
  };

  const removeFile = (fileName) => {
    setFiles((prev) => prev.filter((file) => file.name !== fileName));
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    accept: ".jpg,.jpeg,.png,.gif,.pdf,.docx,.xlsx,.txt,.zip",
  });

  const handleSubmit = async () => {
    const adminID = localStorage.getItem("adminID");
    if (!adminID) {
      alert("Admin ID not found in local storage.");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    formData.append("admin_id", adminID);
    formData.append("project_id", project_id);

    let fileProgress = {};
    files.forEach(file => fileProgress[file.name] = 0);
    setProgress(fileProgress);

    try {
      const response = await axios.post(`${baseurl}uploadFileAdmin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          if (e.total) {
            const percent = Math.round((e.loaded * 100) / e.total);
            setProgress((prev) => ({ ...prev, global: percent }));
          }
        },
      });

      if (response.status === 201) {
        toast.success("Files uploaded successfully!");
        setFiles([]); // Clear input
        // Refetch uploaded files
        const res = await axios.get(`${baseurl}getFilesByProjectId/${project_id}`);
        if (res.data.success) setUploadedFiles(res.data.files);
      } else {
        toast.error("Upload failed: " + response.data.message);
      }
    } catch (err) {
      toast.error("Error uploading: " + err.message);
    }
  };

  return (
    <div className=" ">
      <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />

      {/* Button to show dropzone */}
      {!showDropzone && (
        <div
          type="button"
          onClick={() => setShowDropzone(true)}
          className="btn-sm custom-btn green"
        >
          Upload Files
        </div>
      )}

      {showDropzone && (
        <div className="mb-3 text-start">
          <label className="form-label ">Files</label>
          <div {...getRootProps()} style={{ border: '2px dashed #007bff', padding: '20px', cursor: 'pointer' }}>
            <input {...getInputProps()} />
            <p>Drag & drop some files here, or click to select</p>
            <i>Allowed format: [.jpg,.jpeg,.png,.gif,.pdf,.docx,.xlsx,.txt,.zip] </i>
          </div>
        </div>
      )}

      {/* Selected files preview */}
      {files.length > 0 && (
        <div className="file-list-container mt-3">
          <ul className="file-list">
            {files.map((file, index) => {
              const ext = file.name.split('.').pop().toLowerCase();
              return (
                <li key={index} className="d-flex align-items-center justify-content-between mb-2">
                  <div className="d-flex align-items-center gap-2">
                    {ext === "pdf" && <FileText size={20} />}
                    {["jpg", "jpeg", "png", "gif"].includes(ext) && <Image size={20} />}
                    {["docx", "xlsx", "zip"].includes(ext) && <File size={20} />}
                    {ext === "txt" && <FilePlus size={20} />}
                    <span>{file.name}</span>
                  </div>
                  <button className="btn btn-sm btn-danger" onClick={() => removeFile(file.name)}>Remove</button>
                </li>
              );
            })}
          </ul>

          <div className="text-end mt-3">
            <button className="btn-sm custom-btn green" onClick={handleSubmit}>
              Upload Files
            </button>
          </div>
        </div>
      )}

      {/* Uploaded files section */}
      <div className="mt-4">
        <h6 className="text-start add-task11 text-start  ">Added Files</h6>
        {uploadedFiles.length === 0 ? (
          <p className="text-start">No files uploaded yet.</p>
        ) : (
          <ul className="list-group">
            {uploadedFiles.map((file) => (
              <li key={file.id} className="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <File size={18} className="me-2" />
                  {file.file_name}
                </div>
                <div className="d-flex gap-2">
                  <a
                    href={`${imageUrl}files/${file.file_name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-sm custom-btn blue  "
                  >
                    <ExternalLink size={14} />  
                  </a>
                  <a
                    href={`${imageUrl}files/${file.file_name}`}
                    download
                    className="btn-sm custom-btn green"
                  >
                    <Download size={14} />  
                  </a>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AddFiles;
